// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'infinity';

export const Component = () => (
  <path
    fill='currentColor'
    d='M8.828 5.777 5.897 2.881 0 8.777l5.897 5.897 2.93-2.896-2.999-3 3-3zm8.827 3-5.93-5.897-2.897 2.896 2.965 3-2.965 3 2.896 2.896 5.931-5.896z'
  />
);

export const viewBox = '0 0 18 18';
